import React, { useState } from 'react';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import CloseIcon from '@mui/icons-material/Close';

function apiRequest(path, options = {}) {
  const token = localStorage.getItem('school-token') || '';
  return fetch(path, {
    ...options,
    headers: {
      'x-access-token': token,
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...(options.headers || {}),
    },
  }).then(async response => ({
    ok: response.ok,
    status: response.status,
    data: await response.json().catch(() => ({})),
  }));
}

export default function ManualExamMissedAction({ css, actionCss = css, actor, examMode = 'manual', examId, examTitle, membershipId, student, disabled, compact = false, onMarked }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const basePath = `/${actor === 'teacher' ? 'teacher' : 'school'}/exams/${examId}`;
  const modePath = examMode === 'manual_scores' ? 'manual-score' : 'manual';
  const studentName = student ? `${student.firstName || ''} ${student.lastName || ''}`.trim() : 'this student';

  const close = () => {
    if (!busy) {
      setOpen(false);
      setError('');
    }
  };

  const markMissed = async () => {
    setBusy(true);
    setError('');
    const result = await apiRequest(`${basePath}/${modePath}/${membershipId}/missed`, {
      method: 'POST',
      body: JSON.stringify({}),
    });
    if (result.ok) {
      setOpen(false);
      onMarked?.();
    } else {
      setError(result.data.error || 'Could not mark this exam missed.');
    }
    setBusy(false);
  };

  return (
    <>
      <button
        type="button"
        className={actionCss.btnDanger}
        disabled={disabled || busy}
        title="Mark this student's exam as missed"
        onClick={event => { event.stopPropagation(); setError(''); setOpen(true); }}
        style={compact ? { padding: '3px 9px', fontSize: '0.72rem', lineHeight: 1.4, gap: 4, whiteSpace: 'nowrap' } : undefined}
      >
        <EventBusyIcon style={compact ? { fontSize: '0.9rem' } : undefined} fontSize={compact ? undefined : 'small'} /> {compact ? 'Missed' : 'Mark Exam Missed'}
      </button>
      {open && (
        <div className={css.modalOverlay} onClick={event => { event.stopPropagation(); close(); }}>
          <div className={`${css.modal} BubblePopIn`} style={{ maxWidth: 420, width: '92vw' }} onClick={event => event.stopPropagation()}>
            <div className={css.modalHeader}>
              <h2 className={css.modalTitle}>Mark Exam Missed</h2>
              <button type="button" className={css.closeBtn} onClick={close} aria-label="Close"><CloseIcon fontSize="small" /></button>
            </div>
            <div className={css.modalBody}>
              <p className={css.modalSub}>
                Mark <strong>{studentName}</strong> as missed for <strong>{examTitle || 'this exam'}</strong>?
              </p>
              <p style={{ color: '#546e7a', fontSize: '0.86rem', lineHeight: 1.55, margin: 0 }}>
                The student and the parent or guardian will be notified. This action cannot be undone from the grading screen.
              </p>
              {error && <div className={css.inlineError} style={{ marginTop: 12 }}>{error}</div>}
            </div>
            <div className={css.modalFooter} style={{ flexWrap: 'wrap' }}>
              <button type="button" className={actionCss.btnSecondary} onClick={close} disabled={busy}>Cancel</button>
              <button type="button" className={actionCss.btnDanger} onClick={markMissed} disabled={busy}>
                {busy ? 'Marking...' : 'Confirm Missed Exam'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
